import keycloakService from "../libs/keycloak-service"

const state = {
    keycloakService,
};

const mutations = {};

const getters = {
    getToken(state) {
        return state.keycloakService.getToken();
    },
    getTokenParsed(state) {
        return state.keycloakService.getTokenParsed();
    },
    getAccountUrl(state) {
        return state.keycloakService.getAccountUrl();
    }
};

const actions = {
    loginRequired() {
        return this.dispatch("authenticator/doLogin")
            .then(() => {
                return Promise.all(
                    [
                        this.getters["authenticator/getToken"],
                        this.getters["authenticator/getTokenParsed"],
                        this.getters["authenticator/getAccountUrl"],
                    ]
                );
            })
            .then(([token, tokenParsed, accountUrl]) => {
                const { typ, grupo_economico, exp } = tokenParsed;

                const userData = {
                    accountUrl: accountUrl,
                    grupo_economico
                };


                const tokenInfo = {
                    access_token: token,
                    token_type: typ,
                    expires_in: exp,
                };

                return [userData, tokenInfo];
            })
            .then(([userData, tokenInfo]) => {
                console.log(userData, tokenInfo);
                return [userData, tokenInfo];
            })
            .then(([userData, tokenInfo]) => {
                const userDataPyload = {
                    userData,
                    tokenInfo,
                    redirect: false
                };

                return this.dispatch(
                    "userData/getUserData",
                    userDataPyload,
                    { root: true }
                );
            })
            .then(() => {
                console.log("authenticator login required done");
            });
    },
    doLogin({state}) {
        const loginCallback = (authenticated) => {
            if(!authenticated) {
                throw Error(
                    'On authenticator#doLogin: User not authenticated'
                );
            }
        };

        return state.keycloakService
            .login()
            .then(loginCallback)
            .then(() => {
                console.log(
                    'On authenticator#doLogin: User authenticated'
                );
            });
    },
    doLogout({state}) {
        return state.keycloakService
            .logout()
            .then(() => {
                console.log(
                    'On authenticator#doLogout: User logout well done'
                );
            });
    }

};

export default {
    namespaced: true,
    root: true,
    state,
    actions,
    mutations,
    getters
}
